import { isAnyJobsCategory } from '@kijiji/category'

type ZipRecruiterListingLike = {
  adSource?: string | null
  categoryId?: number | null
}

export const isListingFromZipRecruiter = (listing?: ZipRecruiterListingLike): boolean => {
  if (!listing) return false

  const isJobsCategory = isAnyJobsCategory(listing.categoryId ?? 0)
  if (!isJobsCategory) return false

  const adSource = listing.adSource ?? ''
  return adSource === 'ZIP'
}
